import React, { Component } from 'react';
import { Link, Location } from 'react-router-dom';

import Layout from '../Layouts/Layout';


class Friends extends Component {

    render() {
        return (
            <div>
                <Layout>
                    <p> friends page</p>
                </Layout>
            </div>
        )
    }

}

export default Friends;


// WEBPACK FOOTER //
// src/components/Friends/Friends.js